export const ON_SUCCESS_NOTIFICATION_HIDE = "ON_SUCCESS_NOTIFICATION_HIDE";
